import { transform } from './StoresTransformers';

export default class StoresApiClient {
  constructor() {
    const { COUNTRY, LANGUAGE, API } = CONFIG;
    this.apiUrl = `${API.STORES.HOST}/${COUNTRY}/${LANGUAGE}/meta-data/informera/stores-suggested-detailed.json`;
  }

  getStores() {
    return fetch(this.apiUrl, {
      method: 'GET'
    })
      .then(response => {
        return response.status === 200 ? response.json() : [];
      })
      .then(data => {
        return transform(data);
      })
      .catch(() => {
        return [];
      });
  }
}
